/**
 * Client mirrors of visitTciStates derived views.
 * Keep in sync with functions/src/entitlements/visitTciStates.js
 */

export function derivePatientTciIds(visitTciStates) {
  const states = visitTciStates && typeof visitTciStates === "object" ? visitTciStates : {};
  return Object.keys(states).filter((tciId) => {
    const entry = states[tciId];
    if (!entry || entry.status !== "offered") return false;
    return entry.initiationMode === "patient" || entry.initiationMode === "either";
  });
}

export function deriveQueuedTciIds(visitTciStates) {
  const states = visitTciStates && typeof visitTciStates === "object" ? visitTciStates : {};
  return Object.keys(states).filter((tciId) => {
    const entry = states[tciId];
    if (!entry || entry.status !== "offered") return false;
    return entry.initiationMode === "clinician" || entry.initiationMode === "either";
  });
}
